import React, { useEffect, useState } from "react";
import { Flex, Menu, MenuButton, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { colours } from "@/utils/themeUtils";
import { ChakraFAIcon } from "@/components/ui/Icon";

export enum StudentSortOrderEnum {
	LastNameAscending = "lastNameAscending",
	FirstNameAscending = "firstNameAscending",
}

interface Props {
	studentSortOrder: StudentSortOrderEnum;
	onSortOrderChange: (sortOrder: StudentSortOrderEnum) => void;
}

export function StudentSortOrder(props: Props): JSX.Element {
	const [sortText, setSortText] = useState(
		props.studentSortOrder === StudentSortOrderEnum.LastNameAscending ? "Last Name A-Z" : "First Name A-Z"
	);

	useEffect(() => {
		setSortText(props.studentSortOrder === StudentSortOrderEnum.LastNameAscending ? "Last Name A-Z" : "First Name A-Z");
	}, [props.studentSortOrder]);

	const sortByFirstName = () => {
		setSortText("First Name A-Z");
		props.onSortOrderChange(StudentSortOrderEnum.FirstNameAscending);
	};

	const sortByLastName = () => {
		setSortText("Last Name A-Z");
		props.onSortOrderChange(StudentSortOrderEnum.LastNameAscending);
	};

	return (
		<Flex>
			<Menu>
				<MenuButton>
					<Flex
						height={"26px"}
						alignItems={"center"}
						px={3}
						gap={2}
						color={colours.blueGray[600]}
						border={`1px solid ${colours.blueGray[300]}`}
						borderRadius={"md"}
						cursor={"pointer"}
					>
						<Text fontFamily="Roboto" fontWeight={500}>
							Sort by:
						</Text>
						<Text fontFamily="Roboto">{sortText}</Text>
						<ChakraFAIcon icon="fa-chevron-down" variant="solid" />
					</Flex>
				</MenuButton>
				<MenuList zIndex={10} mt="-5px" background={"transparent"} border={`1px solid ${colours.blueGray[300]}`} borderRadius={"md"} py={0}>
					<MenuItem
						w={props.studentSortOrder === StudentSortOrderEnum.LastNameAscending ? "187px" : "188px"}
						px={3}
						height={"26px"}
						color={colours.blueGray[600]}
						background="transparent"
						_hover={{ background: "transparent" }}
						onClick={() => {
							if (props.studentSortOrder === StudentSortOrderEnum.LastNameAscending) {
								sortByFirstName();
							} else {
								sortByLastName();
							}
						}}
					>
						{props.studentSortOrder === StudentSortOrderEnum.LastNameAscending ? "First Name A-Z" : "Last Name A-Z"}
					</MenuItem>
				</MenuList>
			</Menu>
		</Flex>
	);
}
